// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --social-insight-primary-color: #4A90E2; /* Modern Blue */
  --social-insight-secondary-color: #1B1F3B; /* Dark Navy */
  --social-insight-accent-color: #FFB400; /* Warm Gold */
  --social-insight-background-dark: #0E121E; /* Cyber Black */
  --social-insight-text-color: #E0E0E0; /* Bright White */
  --social-insight-subtext-color: #A8A8A8; /* Soft Grey */
  --social-insight-input-background: #2C2F48; /* Dark Blue */
  --social-insight-hover-color: #306BAC; /* Button hover */
  --social-insight-border-glow: 0 0 10px var(--social-insight-accent-color);
}
/* General Styling */
/* body {
  margin: 0;
  background-color: var(--social-insight-background-dark);
  font-family: 'Arial', sans-serif;
  overflow: hidden;
} */

.social-insight-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: radial-gradient(circle, #113B5B 10%, #0D2740 50%, #071A2E 100%);
  overflow: hidden;
  perspective: 1000px;
}

/* Matrix Effect Background */
.social-insight-background-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}


/* Floating Elements */
.social-insight-floating-elements {
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  transform-style: preserve-3d;
}

.social-insight-floating-element {
  position: absolute;
  animation: float 6s ease-in-out infinite;
  transform-style: preserve-3d;
}

.social-insight-floating-element:nth-child(1) { top: 20%; left: 10%; animation-delay: 0s; transform: translateZ(50px); }
.social-insight-floating-element:nth-child(2) { top: 40%; right: 15%; animation-delay: -2s; transform: translateZ(-30px); }
.social-insight-floating-element:nth-child(3) { bottom: 30%; left: 20%; animation-delay: -4s; transform: translateZ(20px); }
.social-insight-floating-element:nth-child(4) { bottom: 20%; right: 25%; animation-delay: -1s; transform: translateZ(-50px); }

@keyframes social-insight-float {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

/* Social Icons */
.social-insight-social-icon-wrapper {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  background: rgba(0, 255, 43, 0.1);
  border: 1px solid var(--social-insight-primary-color);
  pointer-events: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
  transform-style: preserve-3d;
}

.social-insight-social-icon-wrapper:hover {
  transform: scale(1.1) translateZ(20px);
}

.social-insight-social-icon-wrapper::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  border: 1px solid var(--social-insight-primary-color);
  border-radius: 50%;
  animation: rotateBg 10s linear infinite;
  opacity: 0.3;
}

.social-insight-social-icon {
  font-size: 20px;
  color: var(--social-insight-primary-color);
  z-index: 2;
  transition: all 0.3s ease;
  width: 20px;
  height: 20px;
}

@keyframes rotateBg {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}



/* Login/Signup Form */
.social-insight-cyber-container {
  background: #000000;
  border: 2px solid var(--social-insight-primary-color);
  border-radius: 8px;
  padding: 40px;
  width: 100%;
  max-width: 400px;

  position: relative;
  overflow: hidden;
  z-index: 1;
  animation: fadeInUp 0.8s ease-out;
  transform-style: preserve-3d;
  transform: translateZ(100px);
}

.social-insight-form-container {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
}

.social-insight-form-header {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.social-insight-form-header h1 {
  color: var(--social-insight-primary-color);
  margin: 0 0 15px 0;
  font-size: 2em;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 0 10px var(--social-insight-primary-color);
  position: relative;
}

.social-insight-form-header h2 {
  color: #a9c1c9; /* Neon blue text color */
  margin: 0 0 15px 0;
  font-size: 1.3em;
  text-transform: uppercase;
  letter-spacing: 2px;
 
  position: relative;
}



/* Logo Animation */
.social-insight-logo {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
 
  position: relative;
  transform-style: preserve-3d;
  transform: translateZ(30px);
  animation: social-insight-logoPulse 2s infinite alternate ease-in-out;
}

.social-insight-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes social-insight-logoPulse {
  0% { transform: scale(1); filter: drop-shadow(0px 0px 5px rgba(0, 255, 0, 0.5)); }
  100% { transform: scale(1.05); filter: drop-shadow(0px 0px 15px rgba(0, 255, 0, 1)); }
}

/* Input fields */
.social-insight-input-group {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
}

.social-insight-password-input-wrapper {
  position: relative;
  width: 100%;
}

/* Password Reveal Icon */
.social-insight-password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--social-insight-primary-color);
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  z-index: 2;
}

.social-insight-input-group input,
.social-insight-password-input-wrapper input {
  width: 100%;
  padding: 12px;
  padding-right: 40px;
  background: rgba(0, 255, 43, 0.05);
  border: 2px solid var(--social-insight-primary-color);
  border-radius: 4px;
  color: var(--social-insight-text-color);
  font-size: 16px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  transform: translateZ(10px);
}

.social-insight-input-group input:focus,
.social-insight-password-input-wrapper input:focus {
  border-color: var(--social-insight-primary-dark);
  box-shadow: 0 2px 4px rgba(0, 255, 43, 0.2);
  background: rgba(0, 255, 43, 0.1);
  transform: translateZ(20px);
}


/* Button */
.social-insight-cyber-button {
  width: 100%;
  padding: 12px;
  background: transparent;
  border: 2px solid var(--social-insight-primary-color);
  color: var(--social-insight-primary-color);
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-top: 20px;
  border-radius: 4px;
  z-index: 1;
  transform-style: preserve-3d;
  transform: translateZ(15px);
}

/* Switch Text */
.social-insight-switch-text {
  text-align: center;
  color: var(--social-insight-text-color);
  margin-top: 20px;
}

.social-insight-switch-link {
  color: #0080ff;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  padding: 0 5px;
  text-shadow: 0 0 10px #0080ff;
}

@keyframes social-insight-buttonGlow {
  0% { box-shadow: 0 0 5px var(--social-insight-primary-color); }
  50% { box-shadow: 0 0 20px var(--social-insight-primary-color); }
  100% { box-shadow: 0 0 5px var(--social-insight-primary-color); }
}
`, "",{"version":3,"sources":["webpack://./src/Login/temp/Login.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC,EAAE,gBAAgB;EACzD,yCAAyC,EAAE,cAAc;EACzD,sCAAsC,EAAE,cAAc;EACtD,yCAAyC,EAAE,gBAAgB;EAC3D,oCAAoC,EAAE,iBAAiB;EACvD,uCAAuC,EAAE,cAAc;EACvD,0CAA0C,EAAE,cAAc;EAC1D,qCAAqC,EAAE,iBAAiB;EACxD,yEAAyE;AAC3E;AACA,oBAAoB;AACpB;;;;;GAKG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,2EAA2E;EAC3E,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;;AAGA,sBAAsB;AACtB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA,gDAAgD,QAAQ,EAAE,SAAS,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;AACvH,gDAAgD,QAAQ,EAAE,UAAU,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;AAC1H,gDAAgD,WAAW,EAAE,SAAS,EAAE,oBAAoB,EAAE,2BAA2B,EAAE;AAC3H,gDAAgD,WAAW,EAAE,UAAU,EAAE,oBAAoB,EAAE,4BAA4B,EAAE;;AAE7H;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,yCAAyC,EAAE;EACjD,OAAO,uCAAuC,EAAE;AAClD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,qDAAqD;EACrD,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;;;AAIA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;;EAEhB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,yBAAyB;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;;EAEnB,kBAAkB;AACpB;;;;AAIA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,KAAK,mBAAmB,EAAE,qDAAqD,EAAE;EACjF,OAAO,sBAAsB,EAAE,oDAAoD,EAAE;AACvF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,qDAAqD;EACrD,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,gDAAgD;EAChD,2CAA2C;EAC3C,iCAAiC;EACjC,2BAA2B;AAC7B;;;AAGA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qDAAqD;EACrD,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,KAAK,uDAAuD,EAAE;EAC9D,MAAM,wDAAwD,EAAE;EAChE,OAAO,uDAAuD,EAAE;AAClE","sourcesContent":[":root {\n  --social-insight-primary-color: #4A90E2; /* Modern Blue */\n  --social-insight-secondary-color: #1B1F3B; /* Dark Navy */\n  --social-insight-accent-color: #FFB400; /* Warm Gold */\n  --social-insight-background-dark: #0E121E; /* Cyber Black */\n  --social-insight-text-color: #E0E0E0; /* Bright White */\n  --social-insight-subtext-color: #A8A8A8; /* Soft Grey */\n  --social-insight-input-background: #2C2F48; /* Dark Blue */\n  --social-insight-hover-color: #306BAC; /* Button hover */\n  --social-insight-border-glow: 0 0 10px var(--social-insight-accent-color);\n}\n/* General Styling */\n/* body {\n  margin: 0;\n  background-color: var(--social-insight-background-dark);\n  font-family: 'Arial', sans-serif;\n  overflow: hidden;\n} */\n\n.social-insight-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n  position: relative;\n  background: radial-gradient(circle, #113B5B 10%, #0D2740 50%, #071A2E 100%);\n  overflow: hidden;\n  perspective: 1000px;\n}\n\n/* Matrix Effect Background */\n.social-insight-background-canvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n\n/* Floating Elements */\n.social-insight-floating-elements {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n  transform-style: preserve-3d;\n}\n\n.social-insight-floating-element {\n  position: absolute;\n  animation: float 6s ease-in-out infinite;\n  transform-style: preserve-3d;\n}\n\n.social-insight-floating-element:nth-child(1) { top: 20%; left: 10%; animation-delay: 0s; transform: translateZ(50px); }\n.social-insight-floating-element:nth-child(2) { top: 40%; right: 15%; animation-delay: -2s; transform: translateZ(-30px); }\n.social-insight-floating-element:nth-child(3) { bottom: 30%; left: 20%; animation-delay: -4s; transform: translateZ(20px); }\n.social-insight-floating-element:nth-child(4) { bottom: 20%; right: 25%; animation-delay: -1s; transform: translateZ(-50px); }\n\n@keyframes social-insight-float {\n  0% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(5deg); }\n  100% { transform: translateY(0px) rotate(0deg); }\n}\n\n/* Social Icons */\n.social-insight-social-icon-wrapper {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border-radius: 50%;\n  background: rgba(0, 255, 43, 0.1);\n  border: 1px solid var(--social-insight-primary-color);\n  pointer-events: auto;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  transform-style: preserve-3d;\n}\n\n.social-insight-social-icon-wrapper:hover {\n  transform: scale(1.1) translateZ(20px);\n}\n\n.social-insight-social-icon-wrapper::before {\n  content: '';\n  position: absolute;\n  width: 200%;\n  height: 200%;\n  border: 1px solid var(--social-insight-primary-color);\n  border-radius: 50%;\n  animation: rotateBg 10s linear infinite;\n  opacity: 0.3;\n}\n\n.social-insight-social-icon {\n  font-size: 20px;\n  color: var(--social-insight-primary-color);\n  z-index: 2;\n  transition: all 0.3s ease;\n  width: 20px;\n  height: 20px;\n}\n\n@keyframes rotateBg {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n\n\n/* Login/Signup Form */\n.social-insight-cyber-container {\n  background: #000000;\n  border: 2px solid var(--social-insight-primary-color);\n  border-radius: 8px;\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  animation: fadeInUp 0.8s ease-out;\n  transform-style: preserve-3d;\n  transform: translateZ(100px);\n}\n\n.social-insight-form-container {\n  width: 100%;\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.social-insight-form-header {\n  margin-bottom: 30px;\n  text-align: center;\n  position: relative;\n}\n\n.social-insight-form-header h1 {\n  color: var(--social-insight-primary-color);\n  margin: 0 0 15px 0;\n  font-size: 2em;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-shadow: 0 0 10px var(--social-insight-primary-color);\n  position: relative;\n}\n\n.social-insight-form-header h2 {\n  color: #a9c1c9; /* Neon blue text color */\n  margin: 0 0 15px 0;\n  font-size: 1.3em;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n \n  position: relative;\n}\n\n\n\n/* Logo Animation */\n.social-insight-logo {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n \n  position: relative;\n  transform-style: preserve-3d;\n  transform: translateZ(30px);\n  animation: social-insight-logoPulse 2s infinite alternate ease-in-out;\n}\n\n.social-insight-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@keyframes social-insight-logoPulse {\n  0% { transform: scale(1); filter: drop-shadow(0px 0px 5px rgba(0, 255, 0, 0.5)); }\n  100% { transform: scale(1.05); filter: drop-shadow(0px 0px 15px rgba(0, 255, 0, 1)); }\n}\n\n/* Input fields */\n.social-insight-input-group {\n  position: relative;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.social-insight-password-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* Password Reveal Icon */\n.social-insight-password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--social-insight-primary-color);\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  z-index: 2;\n}\n\n.social-insight-input-group input,\n.social-insight-password-input-wrapper input {\n  width: 100%;\n  padding: 12px;\n  padding-right: 40px;\n  background: rgba(0, 255, 43, 0.05);\n  border: 2px solid var(--social-insight-primary-color);\n  border-radius: 4px;\n  color: var(--social-insight-text-color);\n  font-size: 16px;\n  outline: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  transform: translateZ(10px);\n}\n\n.social-insight-input-group input:focus,\n.social-insight-password-input-wrapper input:focus {\n  border-color: var(--social-insight-primary-dark);\n  box-shadow: 0 2px 4px rgba(0, 255, 43, 0.2);\n  background: rgba(0, 255, 43, 0.1);\n  transform: translateZ(20px);\n}\n\n\n/* Button */\n.social-insight-cyber-button {\n  width: 100%;\n  padding: 12px;\n  background: transparent;\n  border: 2px solid var(--social-insight-primary-color);\n  color: var(--social-insight-primary-color);\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  margin-top: 20px;\n  border-radius: 4px;\n  z-index: 1;\n  transform-style: preserve-3d;\n  transform: translateZ(15px);\n}\n\n/* Switch Text */\n.social-insight-switch-text {\n  text-align: center;\n  color: var(--social-insight-text-color);\n  margin-top: 20px;\n}\n\n.social-insight-switch-link {\n  color: #0080ff;\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: none;\n  position: relative;\n  padding: 0 5px;\n  text-shadow: 0 0 10px #0080ff;\n}\n\n@keyframes social-insight-buttonGlow {\n  0% { box-shadow: 0 0 5px var(--social-insight-primary-color); }\n  50% { box-shadow: 0 0 20px var(--social-insight-primary-color); }\n  100% { box-shadow: 0 0 5px var(--social-insight-primary-color); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
